<template>
  <div id="#glob">
    <h3>Azimut-monitoring reporting - prod links</h3>
    <div id="prod" class="nav">
      <router-link to="/reports/noise/day/5514/2020/10/20/fr-fr#nocache"
        >noise day</router-link
      >|
      <router-link to="/reports/noise/month/2409/2020/10/20/fr-fr#nocache"
        >noise month</router-link
      >|
      <router-link to="/reports/noise/year/2409/2020/10/20/fr-fr#nocache"
        >noise year</router-link
      >|
      <router-link to="/reports/racing/day/7401/2020/10/20/fr-fr#nocache"
        >racing day</router-link
      >|
      <router-link to="/reports/racing/week/7400/2020/10/20/fr-fr#nocache"
        >racing week</router-link
      >|
      <router-link to="/reports/racing/month/7400/2020/10/20/fr-fr#nocache"
        >racing month</router-link
      >|
      <router-link to="/reports/no2/day/2975/2020/10/20/en-us"
        >NO2 day</router-link
      >|
      <router-link to="/reports/no2/month/2975/2020/10/20/en-us"
        >NO2 month</router-link
      >|
      <router-link to="/reports/no2/year/2975/2020/10/20/en-us"
        >NO2 year</router-link
      >|
      <router-link to="/reports/pf/day/5638/2020/10/20/en-us"
        >PF day</router-link
      >|
      <router-link to="/reports/pf/month/5638/2020/10/20/en-us"
        >PF month</router-link
      >|
      <router-link to="/reports/eden/week/n_5026/2020/10/20/fr-fr"
        >Eden wk</router-link
      >|
      <router-link to="/CalibrationUI">Banc de test Calibration</router-link>|
      <router-link to="/reports/constructionSiteNoise/day/6739/2018/08/16/fr-fr#nocache"
        >constructionSite noise day</router-link
      >|
      <router-link
        to="/reports/constructionSitenOISE/week/6739/2018/08/16/fr-fr#nocache"
        >constructionSite noise week</router-link
      >|
      <router-link
        to="/reports/constructionSiteVibration/day/775/2020/10/20/fr-fr#nocache"
        >constructionSite vibration day</router-link
      >|
      <router-link
        to="/reports/constructionSiteVibration/week/775/2020/10/20/fr-fr#nocache"
        >constructionSite vibration week</router-link
      >|
      <router-link
        to="/reports/constructionSiteParticle/day/5638/2019/11/07/fr-fr#nocache"
        >constructionSite particle day</router-link
      >|
      <router-link
        to="/reports/constructionSiteParticle/week/7937/2020/10/12/fr-fr#nocache"
        >constructionSite particle week</router-link
      >|
      <router-link to="/reports/constructionSiteBilan/week/775/2020/10/20/fr-fr#nocache"
        >constructionSite bilan week</router-link
      >|
      <router-link
        to="/reports/constructionSiteAffaireFirstPage/week/8/2020/10/20/fr-fr#nocache"
        >constructionSite affaire first page week</router-link
      >|
      <router-link
        to="/reports/constructionSiteAffaireAverage/week/775/2020/10/20/fr-fr#nocache"
        >constructionSite affaire average</router-link
      >|
      <router-link
        to="/reports/constructionSiteAffaireEmplacement/week/775/2019/10/21/fr-fr#nocache"
        >constructionSite affaire emplacement</router-link
      >|
      <!-- <router-link to="/myenv">Env infos</router-link>| -->
      <router-link to="/demo">Demo</router-link>
      <div>{{ url }}</div>
    </div>
    <h3>Azimut-monitoring reporting - QA links</h3>
    <div id="QA" class="nav">
      <router-link to="/reports/noise/day/5514/2019/01/13/fr-fr#nocache"
        >noise day</router-link
      >|
      <router-link to="/reports/noise/month/2409/2019/03/11/fr-fr#nocache"
        >noise month</router-link
      >|
      <router-link to="/reports/noise/year/2409/2019/03/11/fr-fr#nocache"
        >noise year</router-link
      >|
      <router-link to="/reports/no2/day/2975/2019/05/12/en-us"
        >NO2 day</router-link
      >|
      <router-link to="/reports/no2/month/2975/2019/02/12/en-us"
        >NO2 month</router-link
      >|
      <router-link to="/reports/no2/year/2975/2019/02/12/en-us"
        >NO2 year</router-link
      >|
      <router-link to="/reports/pf/day/7000/2019/05/12/en-us"
        >PF day</router-link
      >|
      <router-link to="/reports/pf/month/7000/2019/05/12/en-us"
        >PF month</router-link
      >|
      <!-- <router-link to="/myenv">Env infos</router-link>| -->
      <router-link to="/demo">Demo</router-link>
      <div>{{ url }}</div>
    </div>
    <watermark />
  </div>
</template>

<script>
import {AppSettings} from '@/appmodules/appsettings'
import Watermark from '../components/Watermark'
export default {
  name: 'app',
  components: {
    Watermark
  },
  data: () => ({url: ''}),
  mounted() {
    this.url = new AppSettings().apiBasePath()
  }
}
</script>

<style lang="less">
div.nav {
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue